<template>
  <v-dialog
    v-model="dialog"
    max-width="600"
    :fullscreen="isMobile()"
    persistent
  >
    <v-card class="cor-fundo">
      <v-toolbar color="primary" tile dark extended flat>
        <v-btn icon @click="$router.go(-1)" v-if="isMobile()">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-toolbar-title>Selecionar produtor</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items v-if="!isMobile()">
          <v-btn icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <!-- barra fina de carregamento -->
      <v-progress-linear
        v-show="produtores.carregando"
        indeterminate
        color="white"
        height="2"
      />

      <v-card-text>
        <v-card
          :style="{ 'margin-top': '-40px', 'z-index': 9999 }"
          rounded="lg"
          flat
        >
          <v-card-text>
            <v-text-field
              placeholder="Informe a matrícula ou parte do nome"
              label="Pesquisar"
              v-model="produtores.pesquisa"
              @keyup.enter="onBuscar"
              ref="campoPesquisa"
            />
            <v-btn
              depressed
              rounded
              block
              :loading="produtores.carregando"
              @click="onBuscar"
            >
              Buscar
            </v-btn>
          </v-card-text>
        </v-card>

        <!-- 1) Carregando: esqueletos -->
        <template v-if="produtores.carregando">
          <v-skeleton-loader
            v-for="n in 6"
            :key="n"
            class="mb-2 mt-2"
            type="list-item-two-line"
          />
        </template>

        <!-- 2) Tem resultados: lista -->
        <v-virtual-scroll
          v-else-if="temResultados"
          class="mt-2 transparent"
          :items="produtores.lista"
          item-height="79"
          :height="isMobile() ? `calc(100vh - 275px)` : `calc(100vh - 400px)`"
        >
          <template v-slot:default="{ item }">
            <tile-produtor :key="item.matr" :produtor="item" />
          </template>
        </v-virtual-scroll>

        <!-- 3) Vazio: mensagens diferentes -->
        <v-scale-transition v-else>
          <v-sheet
            class="mt-2 pa-8 text-center rounded-xl d-flex flex-column align-center justify-center empty-state"
            color="grey lighten-5"
            elevation="0"
          >
            <v-icon size="56" class="mb-3" color="primary darken-1">
              {{
                jaBuscou
                  ? "mdi-account-search-outline"
                  : "mdi-information-outline"
              }}
            </v-icon>

            <div class="text-subtitle-1 font-weight-medium mb-1">
              {{
                jaBuscou
                  ? produtores.pesquisa
                    ? `Nenhum produtor encontrado para “${ultPesq}”.`
                    : "Nenhum produtor encontrado."
                  : "Pesquise por matrícula ou nome"
              }}
            </div>

            <div class="text-body-2 mb-4">
              {{
                jaBuscou
                  ? "Tente outro termo de busca."
                  : "Digite no campo acima e toque em “Buscar”."
              }}
            </div>

            <div class="d-flex flex-wrap justify-center">
              <v-btn
                v-if="jaBuscou && produtores.pesquisa"
                outlined
                color="primary"
                class="mx-1 my-1"
                @click="limparBusca"
              >
                <v-icon left>mdi-close-circle-outline</v-icon>Limpar busca
              </v-btn>
            </div>
          </v-sheet>
        </v-scale-transition>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
import TileProdutor from "./TileProdutor.vue";

export default {
  components: { TileProdutor },
  data: () => ({
    dialog: false,
    jaBuscou: false, // controla se já houve tentativa de busca
    ultPesq: "",
  }),
  computed: {
    ...mapState("visitaTecnica", ["produtores"]),
    temResultados() {
      return (
        Array.isArray(this.produtores.lista) && this.produtores.lista.length > 0
      );
    },
  },
  watch: {
    [`produtores.pesquisa`]: function (value) {
      if (value === "") this.jaBuscou = false;
    },
    dialog(open) {
      if (open) {
        this.produtores.pesquisa = "";
        this.produtores.lista = [];
        this.$nextTick(() => {
          setTimeout(() => {
            if (this.$refs.campoPesquisa) {
              this.$refs.campoPesquisa.focus();
            }
          }, 300); // 300ms ≈ tempo da transição do v-dialog
        });
      } else {
        this.$router.go(-1);
      }
    },
  },
  methods: {
    ...mapActions("visitaTecnica", ["buscarProdutores"]),
    isMobile() {
      return this.$mq == "sm";
    },
    onBuscar() {
      this.jaBuscou = true;
      this.ultPesq = this.produtores.pesquisa;
      this.buscarProdutores(); // mantém sua action atual
    },
    limparBusca() {
      // como você já usa v-model diretamente no estado, funciona assim:
      this.produtores.pesquisa = "";
      this.jaBuscou = false;

      this.$nextTick(() => {
        if (this.$refs.campoPesquisa) {
          this.$refs.campoPesquisa.focus();
        }
      });
    },
  },
  mounted() {
    this.dialog = true;
  },
};
</script>

<style>
.empty-state {
  min-height: 40vh;
  border: 1px dashed rgba(33, 150, 243, 0.25);
}
</style>